export const SET_PAGER = 'SET_PAGER'
export const SET_MEASUREMENT = 'SET_MEASUREMENT'
export const RESET_MEASUREMENT = 'RESET_MEASUREMENT'
export const SET_MEASUREMENTS = 'SET_MEASUREMENTS'
export const RESET_PHOTOS = 'RESET_PHOTOS'
export const SET_PHOTOS = 'SET_PHOTOS'
export const SET_PHOTO = 'SET_PHOTO'
export const UPDATE_PHOTOS = 'UPDATE_PHOTOS'
export const SET_CHECKED = 'SET_CHECKED'
export const SET_VO2_ASSESSMENT = 'SET_VO2_ASSESSMENT'
export const SET_VO2_ASSESSMENTS = 'SET_VO2_ASSESSMENTS'

export const STORE_PAGER = 'measurements/pager'
